import React from 'react';
import { Handle, Position } from 'reactflow';
import { getEventTypeColor } from '../EventTypeIndicator';

interface EventNodeData {
  eventType: string;
  version: number;
  timestamp: string;
  causedBy: string | string[] | null;
  source?: string;
  storeName?: string;
  selected?: boolean;
  color: string;
  isOrigin: boolean;
  isAI: boolean;
}

export function EventNode({ data }: { data: EventNodeData }) {
  const dotColor = getEventTypeColor(data.eventType);
  const borderStyle = data.selected
    ? '2px solid #539fe5'
    : data.isAI
      ? '1px dashed #6b5b95'
      : '1px solid #3d4f6b';

  return (
    <>
      <Handle type="target" position={Position.Top} style={{ background: '#539fe5' }} />
      <div style={{
        width: '170px',
        height: '78px',
        background: '#1a2332',
        border: borderStyle,
        borderRadius: '6px',
        padding: '10px 12px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        position: 'relative',
        borderLeft: data.isOrigin ? `3px solid ${dotColor}` : undefined,
      }}>
        {data.isAI && (
          <span style={{ position: 'absolute', top: '4px', right: '6px', fontSize: '10px', color: '#6b5b95' }}>★ AI</span>
        )}
        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
          <span style={{
            width: '8px',
            height: '8px',
            borderRadius: '50%',
            backgroundColor: dotColor,
            display: 'inline-block',
            flexShrink: 0,
          }} />
          <span style={{ color: '#fff', fontSize: '12px', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {data.eventType}
          </span>
        </div>
        <div style={{ color: '#8d9daf', fontSize: '11px', marginTop: '4px' }}>
          v{data.version} · {formatTime(data.timestamp)}
        </div>
        {data.storeName && (
          <div style={{ color: '#6b8ab0', fontSize: '9px', marginTop: '2px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
            {data.storeName}
          </div>
        )}
        {data.isOrigin && !data.storeName && (
          <div style={{ color: '#8d9daf', fontSize: '9px', marginTop: '2px' }}>ORIGIN</div>
        )}
      </div>
      <Handle type="source" position={Position.Bottom} style={{ background: '#539fe5' }} />
    </>
  );
}

function formatTime(ts: string): string {
  try { return new Date(ts).toLocaleTimeString(); } catch { return ts; }
}
